export enum ApiKeyView {
  LIST = 1,
  CREATE = 2,
  CONFIRM = 3,
}
